if (window.location.pathname.includes("ws-cart")) {
    let counter = 0;
    let selector = ".wsg-cart-table";

    const interval = setInterval(() => {
        let element = document.querySelector(selector);
        if (element && element.children.length > 0) {
            BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
            clearInterval(interval);
        } else {
            counter += 100;
        }

        if (counter >= 10000) {
            clearInterval(interval);
        }
    }, 100);
}


document.addEventListener("click", function (e) {
  const btn = e.target.closest('[bss-b2b-btn-quickview]');
  if (!btn) return;

  setTimeout(() => {
      document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`)) 
  }, 1500);
});

